import pkgjson from "../package.json";
import { PaymentsConfig, SiteConfig, SiteMetadata } from "@base/types";


// An empty webappHost sends "Open App" and the login links to the quiz's own
// pages instead of the app, so a missing value must fail the build.
function requireEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing required env var ${name} — set it in .env / the build environment`,
    );
  }
  return value;
}

const coreApiHost = process.env.GATSBY_CORE_URL ?? "";
const webappHost = requireEnv(
  "GATSBY_WEBAPP_URL",
  process.env.GATSBY_WEBAPP_URL,
);
// Set only on funnel-domain deploys whose checkout lives on another domain;
// unset = checkout is a local route (single-domain behavior).
const checkoutHost = process.env.GATSBY_CHECKOUT_URL || undefined;
const stripePublicKey = process.env.GATSBY_STRIPE_PK_V2 ?? "";
const stripeEnv = stripePublicKey.includes("live") ? "live" : "test";
const ddcPixelDatabaseName =
  process.env.GATSBY_DDC_KONNEKTIVE_DATABASE_NAME ?? "";

const ccbill = {
  widgetAppID: process.env.GATSBY_CCBILL_WIDGET_APP_ID ?? "",
};

const defaultCheckoutProvider: SiteConfig["defaultCheckoutProvider"] =
  process.env.GATSBY_DEFAULT_CHECKOUT_PROVIDER === "ccbill"
    ? "ccbill"
    : "konnektive";

export const siteConfig: SiteConfig = {
  webappHost,
  checkoutHost,
  stripePublicKey,
  stripeEnv,
  coreApiHost,
  faviconPath: "src/images/favicon.png",
  ddcPixelDatabaseName,
  ccbill,
  defaultCheckoutProvider,
};

export const siteMetadata: SiteMetadata = {
  brandName: "Lovelica",
  brandUrl: "https://lovelica.com",
  appName: "lovelica-quiz",
  projectName: "lovelica",
  domainName: "lovelica.com",
  title: "Lovelica",
  siteUrl: "https://lovelica.com",
  version: pkgjson.version,
  // Link-preview (Open Graph) image: the hero photo cropped to 1200x630.
  // Served from static/og-image.jpg; must be an absolute URL.
  image: "https://lovelica.com/og-image.jpg",
  email: "hello@lovelica.com",
  description:
    "Lovelica is your AI girlfriend. Pick your girl, chat any time, get photos when you ask, and she remembers you. Private, just the two of you.",
  appVersion: pkgjson.version,
  abTestName: "rebill-3498",
  abTestValue: undefined,
  environment: process.env.NODE_ENV || "development",
  // Company/marketing fields (required by the shared SiteMetadata; consumed by
  // the landing/legal pages, which interpolate them into their copy)
  companyName: "Neontree, UAB",
  companyAddress: "Žemaitės g. 17-6",
  companyCity: "Telšiai",
  companyState: "",
  companyCountry: "Lithuania",
  companyCode: "LT-87133", // postal code, rendered in front of the city
  website: {
    url: "https://lovelica.com",
    title: "lovelica.com",
  },
  webapp: {
    url: "https://app.lovelica.com",
    title: "app.lovelica.com",
  },
};

export const paymentsConfig: PaymentsConfig = {
  paymentConfig: {
    usd: {
      currency: "usd",
      currencyLocaleFormat: "en-US",
      paymentCampaignID: "9",
    },
    gbp: {
      currency: "gbp",
      currencyLocaleFormat: "en-GB",
      paymentCampaignID: "17",
    },
    eur: {
      currency: "eur",
      currencyLocaleFormat: "de-DE",
      paymentCampaignID: "19",
    },
    try: {
      currency: "try",
      currencyLocaleFormat: "tr-TR",
      paymentCampaignID: "21",
      priceModifierFactor_experimental: 42,
      minorUnitAmountRounding_experimental: "down",
    },
  },
  defaultPaymentConfig: {
    currency: "usd",
    currencyLocaleFormat: "en-US",
    paymentCampaignID: "9",
    applePayMerchantID: 13,
  },
};
